import { render } from "./ClientPostsToolbar.vue?vue&type=template&id=79fb9148&ts=true"
import script from "./ClientPostsToolbar.vue?vue&type=script&lang=ts"
export * from "./ClientPostsToolbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__